import * as React from "react";
type Props = {
  className?: string,
};
function SvgFruits2({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-fruits2"
      className={className}
    >
      <path
        d="M14.2696 18.1502C15.4596 15.0502 17.3996 13.2402 19.5196 12.4002C19.4896 12.3502 19.4696 12.3102 19.4696 12.3102C19.1296 11.7502 18.5796 10.8802 17.5296 10.3302C17.5296 10.3302 16.6896 9.89023 15.6896 9.85023C13.2796 9.76023 10.9596 12.0502 9.85957 14.1102C8.54957 16.5602 8.80957 18.9602 8.96957 19.9102C9.54957 23.3202 12.4996 25.5302 13.1196 26.0302C13.1496 26.1302 12.0796 23.9002 14.2796 18.1502H14.2696Z"
        fill="#EDAB93"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M14.27 18.15C16.79 12.42 20.93 10.8 25.83 12.5C30.21 14.02 30.87 18.84 28.76 23.15C26.26 28.26 20.95 28.08 16.07 28.23C10.72 28.4 13.68 19.48 14.27 18.14V18.15Z"
        fill="#EDAB93"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M19.4097 12.1301C19.4097 12.1301 21.1297 8.33008 25.0997 7.58008"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M21.2099 9.41C21.2099 9.41 14.6799 7.96 16.3499 2C16.3499 2 22.5499 3.35 21.2099 9.41Z"
        fill="#C2DA96"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M5.37981 29.8998C5.09981 30.6898 5.32981 31.3998 5.45981 31.8198C5.93981 33.2598 6.42981 33.9698 7.56981 34.9798C8.03981 35.3898 10.2798 37.4498 15.3598 37.6098C17.5098 37.6798 24.0398 37.6098 24.1298 35.5798C24.3898 35.5298 22.8598 34.5298 21.7998 34.0798C20.8298 33.6698 20.1798 33.6198 19.2998 33.4098C17.6698 33.0298 17.4698 32.6298 15.2998 31.7398C13.7098 31.0898 13.5198 31.1798 9.71981 29.9898C8.16981 29.5098 6.92981 29.0898 6.13981 28.8198C5.92981 29.0098 5.57981 29.3598 5.38981 29.8998H5.37981Z"
        fill="#FFC45C"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M5.54958 29.4897C5.52958 30.0297 5.33958 30.3497 6.15958 31.6597C6.97958 32.9697 9.58958 33.9897 12.0496 34.4797C13.3896 34.7497 14.4596 34.8397 18.2196 34.9797C20.4796 35.0597 22.3696 35.1097 23.7196 35.1497"
        fill="#FFC45C"
      />
      <path
        d="M5.54958 29.4897C5.52958 30.0297 5.33958 30.3497 6.15958 31.6597C6.97958 32.9697 9.58958 33.9897 12.0496 34.4797C13.3896 34.7497 14.4596 34.8397 18.2196 34.9797C20.4796 35.0597 22.3696 35.1097 23.7196 35.1497"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M18.8399 30.74C17.3999 29.03 20.3399 29.65 22.0099 29.58L26.3699 28.95L26.7599 28.71L27.8099 27.86L30.6099 26.38L33.7799 25.13C36.6699 24.13 34.5299 30.41 32.0199 32.45C28.9399 34.96 23.6099 34.29 20.3199 31.99C19.6499 31.52 19.1499 31.05 18.8299 30.73L18.8399 30.74Z"
        fill="#FFC45C"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M32.0997 25.96C31.7797 26.99 31.0797 28.95 29.2497 30.5C24.1697 34.79 21.1497 32.87 19.1997 31.09"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgFruits2;
